import * as Strings from './strings'
import * as Constants from '../Constants'

const BASE_URL_V3 = `${process.env.REACT_APP_API_URL}/api/v3/`

export function parseDate(date) {
  return (
    date.getFullYear() +
    '-' +
    fillDate(1 + date.getMonth()) +
    '-' +
    fillDate(date.getDate())
  )
}

export function getManual(communityId) {
  const url = BASE_URL_V3 + 'admins/communities/' + communityId + '/manual'

  window.open(url)
}

export function isValidEmail(email) {
  //eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  return re.test(String(email).toLowerCase())
}

function fillDate(str) {
  if (str.toString().length === 1) return '0' + str
  return str
}

export function maxBookingsToString(maxBookings) {
  if (maxBookings.toString() === '0') {
    return Strings.default.NO_LIMIT
  } else if (maxBookings.toString() === '1') {
    return Strings.default.MAX_ONE_BOOKING
  }

  return maxBookings + ' ' + Strings.default.BOOKINGS_AT_A_TIME
}

export function bookingRangeToString(bookingRange) {
  if (bookingRange.toString() === '0') {
    return Strings.default.NO_LIMIT
  } else if (bookingRange.toString() === '1') {
    return Strings.default.ONE_WEEK
  }

  return bookingRange + ' ' + Strings.default.WEEKS
}

export function getTimeAgo(date) {
  const today = new Date()
  const formatDate = date.replace(/:|T/g, '-')
  const YMDhms = formatDate.split('-')
  const dateYear = parseInt(YMDhms[0], 10)
  const dateMonth = parseInt(YMDhms[1], 10)
  const dateDay = parseInt(YMDhms[2], 10)
  const dateHours = parseInt(YMDhms[3], 10) + 2
  const dateMinutes = parseInt(YMDhms[4], 10)

  if (
    dateYear === today.getFullYear() &&
    dateMonth === today.getMonth() + 1 &&
    dateDay === today.getDate()
  ) {
    if (dateHours === today.getHours()) {
      const diffMin = today.getMinutes() - dateMinutes

      if (diffMin < 0) {
        return '0 min'
      }

      return today.getMinutes() - dateMinutes + ' min'
    } else if (dateHours + 1 === today.getHours()) {
      const minutesUntilWhole = 60 - dateMinutes
      const minutesSincePost = minutesUntilWhole + today.getMinutes()

      return minutesSincePost + ' min'
    }
    const diffHours = today.getHours() - dateHours

    if (diffHours < 0) {
      return '0 min'
    }

    return today.getHours() - dateHours + ' h'
  } else if (
    dateYear === today.getFullYear() &&
    dateMonth === today.getMonth() + 1
  ) {
    return today.getDate() - dateDay + ' d'
  }

  return (
    dateYear +
    '-' +
    YMDhms[1] +
    '-' +
    YMDhms[2] +
    ' ' +
    YMDhms[3] +
    ':' +
    YMDhms[4] +
    ':' +
    YMDhms[5].split('.')[0]
  )
}

function desc(a, b, orderBy, sortType) {
  if (
    b[orderBy].toString().toLowerCase() < a[orderBy].toString().toLowerCase()
  ) {
    return 1
  } else if (
    b[orderBy].toString().toLowerCase() > a[orderBy].toString().toLowerCase()
  ) {
    return -1
  }

  return 0
}

export function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index])

  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0])

    if (order !== 0) {
      return order
    }

    return a[1] - b[1]
  })

  return stabilizedThis.map(el => el[0])
}

export function getSorting(order, orderBy, sortType) {
  return order === 'desc'
    ? (a, b) => desc(a, b, orderBy, sortType)
    : (a, b) => -desc(a, b, orderBy, sortType)
}

export function parseDaysToString(days) {
  let string = ''

  Constants.WEEKDAYS_ARRAY.forEach(d => {
    if (days.indexOf(d) !== -1) {
      string = string + d + ';'
    }
  })

  return string.slice(0, -1)
}



// WEBPACK FOOTER //
// ./src/helpers/Functions/index.js